import * as Yup from "yup";
// const generalErrorMessge = "Field is required";
// export const validationSchemaRequiredFields = Yup.object({
//   pi_program_name: Yup.string()
//     .required("Program Name is required")
//     .min(1, "Program Name is required"),
//   pi_standard_time: Yup.string()
//     .required("Time zone is required")
//     .min(1, "Time zone is required"),
//   pi_program_debit_or_credit: Yup.string()
//     .required("Field is required")
//     .min(1, "Field is required"),
//   pi_card_program: Yup.string().when("pi_program_debit_or_credit", {
//     is: (pi_program_debit_or_credit) =>
//       pi_program_debit_or_credit && pi_program_debit_or_credit === "prepaid",
//     then: () => Yup.string().required("Card Program is required"),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_program_type_prepaid: Yup.number().when("pi_program_debit_or_credit", {
//     is: (pi_program_debit_or_credit) =>
//       pi_program_debit_or_credit && pi_program_debit_or_credit === "prepaid",
//     then: () =>
//       Yup.number()
//         .required("Progran type is required")
//         .min(0, "Progran type is required")
//         .max(2, "Progran type is required")
//         .typeError("Field is required"),
//     otherwise: () => Yup.number().optional(),
//   }),

//   pi_system_records_debit: Yup.array().when("pi_program_debit_or_credit", {
//     is: (pi_program_debit_or_credit) =>
//       pi_program_debit_or_credit && pi_program_debit_or_credit === "debit",
//     then: () =>
//       Yup.array().required(generalErrorMessge).min(1, generalErrorMessge),
//     otherwise: () => Yup.array().optional(),
//   }),
//   pi_system_records_debit_other: Yup.string().when(
//     ["pi_system_records_debit", "pi_program_debit_or_credit"],
//     {
//       is: (pi_system_records_debit, pi_program_debit_or_credit) =>
//         pi_system_records_debit &&
//         pi_system_records_debit.includes(1) &&
//         pi_program_debit_or_credit === "debit",
//       then: () => Yup.string().required("Program type other is required"),
//       otherwise: () => Yup.string().optional(),
//     },
//   ),

//   pi_auth_transac_debit: Yup.array().when("pi_program_debit_or_credit", {
//     is: (pi_program_debit_or_credit) =>
//       pi_program_debit_or_credit && pi_program_debit_or_credit === "debit",
//     then: () =>
//       Yup.array()
//         .required("Program type is required")
//         .min(1, "Program type is required"),
//     otherwise: () => Yup.array().optional(),
//   }),
//   pi_auth_transac_debit_other: Yup.string().when(
//     ["pi_auth_transac_debit", "pi_program_debit_or_credit"],
//     {
//       is: (pi_auth_transac_debit, pi_program_debit_or_credit) =>
//         pi_auth_transac_debit &&
//         pi_auth_transac_debit.includes(1) &&
//         pi_program_debit_or_credit === "debit",
//       then: () => Yup.string().required("Program type other is required"),
//       otherwise: () => Yup.string().optional(),
//     },
//   ),

//   pi_program_type_debit: Yup.array().when("pi_program_debit_or_credit", {
//     is: (pi_program_debit_or_credit) =>
//       pi_program_debit_or_credit && pi_program_debit_or_credit === "debit",
//     then: () =>
//       Yup.array()
//         .required("Program type is required")
//         .min(1, "Program type is required"),
//     otherwise: () => Yup.array().optional(),
//   }),
//   pi_program_type_debit_other: Yup.string().when(
//     ["pi_program_type_debit", "pi_program_debit_or_credit"],
//     {
//       is: (pi_program_type_debit, pi_program_debit_or_credit) =>
//         pi_program_type_debit &&
//         pi_program_type_debit.includes(2) &&
//         pi_program_debit_or_credit === "debit",
//       then: () => Yup.string().required("Program type other is required"),
//       otherwise: () => Yup.string().optional(),
//     },
//   ),
//   pi_selected_commercial_types: Yup.array().when(
//     ["pi_program_type_prepaid", "pi_program_debit_or_credit"],
//     {
//       is: (type, pi_program_debit_or_credit) =>
//         type === 1 && pi_program_debit_or_credit === "prepaid",
//       then: () =>
//         Yup.array()
//           .required("At least one commercial type must be selected")
//           .min(1, "At least one commercial type must be selected"),
//       otherwise: () => Yup.array().optional(),
//     },
//   ),
//   pi_commercial_type_other: Yup.string().when("pi_selected_commercial_types", {
//     is: (types) => types && types.includes(4),
//     then: () => Yup.string().required("Commercial type other is required"),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_selected_consumer_types: Yup.array().when(
//     ["pi_program_type_prepaid", "pi_program_debit_or_credit"],
//     {
//       is: (type, pi_program_debit_or_credit) =>
//         type === 0 && pi_program_debit_or_credit === "prepaid",
//       then: () =>
//         Yup.array()
//           .required("At least one consumer type must be selected")
//           .min(1, "At least one consumer type must be selected"),
//       otherwise: () => Yup.array().optional(),
//     },
//   ),
//   pi_consumer_type_other: Yup.string().when("pi_selected_consumer_types", {
//     is: (types) => types && types.includes(7),
//     then: () => Yup.string().required("Consumer type other is required"),
//     otherwise: () => Yup.string().optional(),
//   }),

//   pi_proposition_value: Yup.string()
//     .required(generalErrorMessge)
//     .min(1, generalErrorMessge),
//   pi_segment_value: Yup.string()
//     .required(generalErrorMessge)
//     .min(1, generalErrorMessge),
//   pi_card_program_currency: Yup.string()
//     .required("Card program currency is required.")
//     .min(1, "Card program curecncy is required."),
//   pi_setup_type: Yup.string()
//     .required("Setup type is required")
//     .min(1, "Setup type is required"),
//   pi_type_of_migration: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "migration",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),

//   pi_type_of_processor_name: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "migration",
//     then: () => Yup.string().required("Bank or Processor name is required."),
//     otherwise: () => Yup.string().optional(),
//   }),
//   //Mine 
//   pi_ecount_1: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_ecount_2: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_ecount_3: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_ecount_4: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evalue_1: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evalue_2: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evalue_3: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evalue_4: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evolume_1: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evolume_2: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evolume_3: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evolume_4: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "new-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),

//   //Below okay
//   pi_ecount_1: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_ecount_2: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_ecount_3: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_ecount_4: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evalue_1: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evalue_2: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evalue_3: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evalue_4: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evolume_1: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evolume_2: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evolume_3: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_evolume_4: Yup.string().when("pi_migration_type", {
//     is: (pi_migration_type) => pi_migration_type === "both" || pi_migration_type === "migration-program",
//     then: () => Yup.string().required(generalErrorMessge),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_mig_np_ecount_1: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_mig_np_ecount_2: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_mig_np_ecount_3: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_mig_np_ecount_4: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_mig_np_evalue_1: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_mig_np_evalue_2: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_mig_np_evalue_3: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_mig_np_evalue_4: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_mig_np_evolume_1: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_mig_np_evolume_2: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_mig_np_evolume_3: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_mig_np_evolume_4: Yup.string()
//     .when("pi_migration_type", {
//       is: (pi_migration_type) =>
//         pi_migration_type === "both" || pi_migration_type === "new-program",
//       then: () => Yup.string().required(generalErrorMessge),
//       otherwise: () => Yup.string().optional(),
//     })
//     .required(generalErrorMessge),
//   pi_current_processor_name: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "migration",
//     then: () => Yup.string().required("Current Processor name is required."),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_migration_type: Yup.string().when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "migration",
//     then: () => Yup.string().required("Migration type is required."),
//     otherwise: () => Yup.string().optional(),
//   }),
//   pi_key_component_custodians: Yup.array(Yup.string()).when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "migration",
//     then: () =>
//       Yup.array(Yup.string())
//         .required("Please select a custodian")
//         .min(1, "At least one Cusodian must be selected"),
//     otherwise: () => Yup.array().optional(),
//   }),
//   pi_key_component_custodians_other: Yup.string().when(
//     "pi_key_component_custodians",
//     {
//       is: (types) => types && types.includes("3"),
//       then: () => Yup.string().required("Custodian is required"),
//       otherwise: () => Yup.string().optional(),
//     },
//   ),
//   pi_data_migration_attributes: Yup.array(Yup.string()).when("pi_setup_type", {
//     is: (pi_setup_type) => pi_setup_type === "migration",
//     then: () =>
//       Yup.array(Yup.string())
//         .required("Please select a migration attribute")
//         .min(1, "At least one migration attribute must be selected"),
//     otherwise: () => Yup.array().optional(),
//   }),
//   pi_data_migration_attributes_other: Yup.string().when(
//     "pi_data_migration_attributes",
//     {
//       is: (attrs) => attrs && attrs.includes("4"),
//       then: () => Yup.string().required("Migration attribute is required."),
//       otherwise: () => Yup.string().optional(),
//     },
//   ),
//   pi_cpm_compliant: Yup.string().required(generalErrorMessge),
//   pi_compliant_certificate: Yup.string().when("pi_cpm_compliant", {
//     is: (pi_cpm_compliant) => pi_cpm_compliant && pi_cpm_compliant === "yes",
//     then: () => Yup.string().optional(),
//     otherwise: () => Yup.string().optional(),
//   }),
// });


export const validationSchema = Yup.object().shape({
    pi_program_name: Yup.string()
    .required("Program Name is required")
    .min(1, "Program Name is required"),
  pi_standard_time: Yup.string()
    .required("Time zone is required")
    .min(1, "Time zone is required"),
  pi_program_debit_or_credit: Yup.string().optional(),

  pi_card_program: Yup.string().optional(),
  pi_program_type_prepaid: Yup.number().optional(),

  pi_system_records_debit: Yup.array().optional(),
  pi_system_records_debit_other: Yup.string().optional(),

  pi_auth_transac_debit: Yup.array().optional(),
  pi_auth_transac_debit_other: Yup.string().optional(),

  pi_program_type_debit: Yup.array().optional(),
  pi_program_type_debit_other: Yup.string().optional(),

  pi_selected_commercial_types: Yup.array().optional(),
  pi_commercial_type_other: Yup.string().optional(),

  pi_selected_consumer_types: Yup.array().optional(),
  pi_consumer_type_other: Yup.string().optional(),

  pi_proposition_value: Yup.string().optional(),
  pi_segment_value: Yup.string().optional(),
  pi_card_program_currency: Yup.string().optional(),

  pi_setup_type: Yup.string().optional(),
  pi_type_of_migration: Yup.string().optional(),
  pi_type_of_processor_name: Yup.string().optional(),

  pi_ecount_1: Yup.string().optional(),
  pi_ecount_2: Yup.string().optional(),
  pi_ecount_3: Yup.string().optional(),
  pi_ecount_4: Yup.string().optional(),

  pi_evalue_1: Yup.string().optional(),
  pi_evalue_2: Yup.string().optional(),
  pi_evalue_3: Yup.string().optional(),
  pi_evalue_4: Yup.string().optional(),

  pi_evolume_1: Yup.string().optional(),
  pi_evolume_2: Yup.string().optional(),
  pi_evolume_3: Yup.string().optional(),
  pi_evolume_4: Yup.string().optional(),

  pi_mig_np_ecount_1: Yup.string().optional(),
  pi_mig_np_ecount_2: Yup.string().optional(),
  pi_mig_np_ecount_3: Yup.string().optional(),
  pi_mig_np_ecount_4: Yup.string().optional(),

  pi_mig_np_evalue_1: Yup.string().optional(),
  pi_mig_np_evalue_2: Yup.string().optional(),
  pi_mig_np_evalue_3: Yup.string().optional(),
  pi_mig_np_evalue_4: Yup.string().optional(),

  pi_mig_np_evolume_1: Yup.string().optional(),
  pi_mig_np_evolume_2: Yup.string().optional(),
  pi_mig_np_evolume_3: Yup.string().optional(),
  pi_mig_np_evolume_4: Yup.string().optional(),

  pi_current_processor_name: Yup.string().optional(),
  pi_migration_type: Yup.string().optional(),

  pi_key_component_custodians: Yup.array().optional(),
  pi_key_component_custodians_other: Yup.string().optional(),

  pi_data_migration_attributes: Yup.array().optional(),
  pi_data_migration_attributes_other: Yup.string().optional(),

  pi_cpm_compliant: Yup.string().optional(),
  pi_compliant_certificate: Yup.string().optional(),
});